import { combineReducers } from 'redux'
import _ from 'lodash'
import { reducers } from '@adc/ui-morpheus'
import { USERS } from '../../constants/tableTypes'
import { UPDATE_USER_IN_LIST } from '../../constants/actionTypes'
import tableReducer from './columnDefinitions'

const initialState = {
  content: [],
  total_elements: 0,
}

const usersReducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_USER_IN_LIST: {
      const users = state
      let result = state
      if (
        users.total_elements > 0 &&
        users.content &&
        users.content.length > 0
      ) {
        const matchIndex = _.findIndex(users.content, {
          user_id: action.user.user_id,
        })
        if (matchIndex > -1) {
          result = {
            ...state,
            content: [
              ...users.content.slice(0, matchIndex),
              action.user,
              ...users.content.slice(matchIndex + 1),
            ],
          }
        }
      }
      return result
    }
    default:
      return reducers.dataTable.tableFetchReducer(USERS, state, action)
  }
}

const usersDownloadReducer = (state = initialState, action) =>
  reducers.dataTable.downloadFetchReducer(USERS, state, action)

export default combineReducers({
  data: usersReducer,
  tableInfo: tableReducer,
  downloadData: usersDownloadReducer,
})

export { initialState, usersReducer }
